/* eslint-disable max-len */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";
import OffsetDateTimeValue from "./core/OffsetDateTimeValue";

/**
 * API[カリキュラム情報・受講履歴取得: /curriculumInfoStudentHistory]のペイロードを表すインターフェース。
 * @export
 * @interface
 *
 * @property {string} curriculumId 研修ID(必須)
 */
export interface CurriculumInfoStudentHistoryPayload {
    curriculumId: string;
}

/**
 * API[カリキュラム情報・受講履歴取得: /curriculumInfoStudentHistory]の正常応答を表すインターフェース。
 * @export
 * @interface
 * @property curriculumInfoData マスタデータ(カリキュラム)
 * @property careers マスタデータ(紐づく研修群)
 * @property categories 表示対象分類
 * @property histories 受講履歴(実施中/実績)
 * @property careerHistories 研修の受講履歴(実施中/実績)
 * @property appliable 受講申請可否
 * @property approvers 承認者リスト
 */
export interface CurriculumInfoStudentHistoryResponse {
    curriculumInfoData: CurriculumInfoData;
    appliable: boolean;
    careers: SubCareers;
    categories: CategoryItem[];
    approvers: Aprovers;
    histories: CurriculumHistories;
    careerHistories: CareerHistories[];
}

export interface CurriculumInfoData {
    curriculumInfo: CurriculumInfo;
    useJinjiZokusei: string;
}
export interface CurriculumInfo {
    careerId: string;
    careerName: string;
    comment: string;
    credit: number;
    level: string;
    division: string;
    field: string;
    managementCode: string;
    organizer: string;
    outline: string;
    purpose: string;
    reference: string;
    referenceUrl: string;
    applicationPlace: string;
    completeJudgment: string;
    target: string;
    targetEmployeeDivisionName: string;
    targetEmployeeDivisionName1: string;
    targetEmployeeDivisionName2: string;
    targetEmployeeDivisionName3: string;
    targetEmployeeDivisionName4: string;
    targetEmployeeDivisionName5: string;
    targetOccupationName: string;
    targetOccupationName1: string;
    targetOccupationName2: string;
    targetOccupationName3: string;
    targetOccupationName4: string;
    targetOccupationName5: string;
    targetOfficeName: string;
    targetOfficeName1: string;
    targetOfficeName2: string;
    targetOfficeName3: string;
    targetOfficeName4: string;
    targetOfficeName5: string;
    targetOrganizeName: string;
    targetPostName: string;
    targetYoungWorker: string;
    targetSectionName1: string;
    targetSectionName2: string;
    targetSectionName3: string;
    targetSectionName4: string;
    targetSectionName5: string;
    targetPostName1: string;
    targetPostName2: string;
    targetPostName3: string;
    targetPostName4: string;
    targetPostName5: string;
    targetYoungWorker1: number;
    targetOldWorker: number;
}
export interface SubCareers {
    required: SubCareer[];
    optional: SubCareer[];
}
export interface SubCareer {
    careerId: string;
    careerName: string;
    careerType: string;
    careerTypeId: string;
    credit: number;
    managementCode: string;
    subCareerSetId: number;
    careerStartDate: OffsetDateTimeValue;
    careerEndDate: OffsetDateTimeValue;
    studyOrder: string;
    careerImageUrl?: string;
}

export interface CategoryItem {
    categoryId: string;
    categoryName: string;
    subCategories: CategoryItem[];
}

export interface Aprovers {
    apply: AproverOptionsApply;
    cancel: AproverOptionsCancel;
}
export interface AproverOptionsApply {
    approverList1: AproverOptionItemApply[];
    approverList2: AproverOptionItemApply[];
}
export interface AproverOptionItemApply {
    id: string;
    name: string;
}
export interface AproverOptionsCancel {
    approverList1: AproverOptionItemCancel[];
    approverList2: AproverOptionItemCancel[];
}
export interface AproverOptionItemCancel {
    userId: string;
    approverOptionString: string;
}

export interface CurriculumHistories {
    onGoing: CurriculumHistoryItemOnGoing[];
    result: CurriculumHistoryItemResult[];
}
export interface CurriculumHistoryItemOnGoing {
    compulsoryId: string;
    careerTitle: string;
    aplType: string;
    appCancelOkFlg: boolean;
    applyDate: string;
    applyUserId: string;
    approvalDate: string;
    approvalUserId: string;
    careerId: string;
    complDate: string;
    compulsoryCssClass: string;
    credit: string;
    lecCancelOkFlg: boolean;
    organizer: string;
    status: string;
    statusId: string;
    target: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
}
export interface CurriculumHistoryItemResult {
    compulsoryId: string;
    careerTitle: string;
    aplType: string;
    appCancelOkFlg: boolean;
    applyDate: string;
    applyUserId: string;
    approvalDate: string;
    approvalUserId: string;
    careerId: string;
    complDate: string;
    compulsoryCssClass: string;
    credit: string;
    lecCancelOkFlg: boolean;
    organizer: string;
    status: string;
    statusId: string;
    target: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
}

export interface CareerHistories {
    careerId: string;
    histories: CareerHistory;
}
export interface CareerHistory {
    onGoing: CareerHistoryItemOnGoing[];
    result: CareerHistoryItemResult[];
}
export interface CareerHistoryItemOnGoing {
    careerId: string;
    careerTitle: string;
    careerTypeId: string;
    compulsoryId: string;
    compulsoryName: string;
    classId: string;
    classroom: string;
    classStatus: string;
    classTitle: string;
    jissiKikan: string;
    jissiEndDateODT: string;
    jissiStartDateODT: string;
    imstatListStatusId: string;
    status: string;
    jukou: string;
    progress: string;
    enqueteDispFlg: boolean;
    taskReportOkFlg: boolean;
    testFlg: boolean;
    appCancelOkFlg: boolean;
    lecCancelOkFlg: boolean;
    appChangeOkFlg: boolean;
    appResultOkFlg: boolean;
    careerImageUrl: string;
    multiApplyFlag: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
    outOfPeriodFlg: boolean;
    kadai: string;
    kadaiWithin: number;
    enquete: string;
    enqueteWithin: number;
    aplType: string;
}
export interface CareerHistoryItemResult {
    careerId: string;
    careerTitle: string;
    careerTypeId: string;
    compulsoryId: string;
    compulsoryName: string;
    classId: string;
    classTitle: string;
    jissiKikan: string;
    jissiEndDateODT: string;
    jissiStartDateODT: string;
    imstatListStatusId: string;
    status: string;
    jukou: string;
    seq: string;
    resultStatus: string;
    multiApplyFlag: string;
    enqueteDispFlg: boolean;
    taskReportOkFlg: boolean;
    testFlg: boolean;
    careerImageUrl: string;
    classroom: string;
    startDate: string;
    endDate: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
    retakeOkFlg: boolean;
    outOfPeriodFlg: boolean;
    kadai: string;
    kadaiWithin: number;
    enquete: string;
    enqueteWithin: number;
}

/**
 * API[カリキュラム情報・受講履歴取得: /curriculumInfoStudentHistory]用のサービスクラス。
 */
class CurriculumInfoStudentHistoryService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "curriculumInfoStudentHistory");
    }

    /**
     * API[カリキュラム情報・受講履歴取得: /curriculumInfoStudentHistory]に対するFetch。
     *
     * @param payload {CurriculumInfoStudentHistoryPayload} ペイロード
     * @returns {Promise<CurriculumInfoStudentHistoryResponse>} 応答データを返すPromise
     */
    public async fetch(payload: CurriculumInfoStudentHistoryPayload): Promise<CurriculumInfoStudentHistoryResponse> {
        return super.postWithPromise(payload).then((json: unknown) => json as CurriculumInfoStudentHistoryResponse);
    }
}

export default CurriculumInfoStudentHistoryService;
